import React, { Component } from 'react';
import check from '../../Images/Icons/check.png';

export default class Multi_Line_Select extends Component {
	constructor(props) {
		super(props);
		this.state = {

		};
	};

	handleClick = (value) => {
		this.props.onSelect(value);
	}

	render() {
		let liStyle = {
			cursor: 'pointer',
			listStyle: 'none',
			fontFamily: 'Arial',
			color: '#5a5a5a',
			padding: 6,
			':hover': {
				opacity: 0.7,
				backgroundColor: '#cac9c9',
			},
			width: this.props.width - 40,
			borderRadius: 20,
			textAlign: 'left',
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
			height: 25,
			marginTop: 10,
			marginBottom: 10,
			marginLeft: 'auto',
			marginRight: 'auto',
		}

		return (
			<div style={{ overflow: 'auto', height: this.props.height }} >
				{this.props.item_list.map((item, i) => {
					return (
						<li tagindex={i} style={liStyle} onClick={() => this.handleClick(item.key)} >
							<div style={{ width: 25, display: item.is_checked ? 'inline-block' : 'none' }}>
								<img src={check} style={{ width: 25 }} />
							</div>
							<div style={{ display: 'inline-block', verticalAlign: 'top', paddingTop: 5, marginLeft: item.is_checked ? 10 : 35, }}>
								{item.display}
							</div>
						</li>
					)
				})}
			</div>
		);
	}
}